import React from 'react';
import { Button, ListGroup, ProgressBar } from 'react-bootstrap';
import '../assets/css/task.css';
import '../assets/css/challenge.css';
import '../assets/css/response.css';
import blueShape from '../assets/images/blue-shape.png';
import challengeImage from '../assets/images/qpage-banner-img.png';
import ordinal_suffix_of from '../components/Ordinal';
import returnJSX from '../components/ReturnJSX';
import returnHint from '../components/ReturnHint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faShoePrints } from '@fortawesome/free-solid-svg-icons';
import Footer from '../components/Footer';
import cgInventLogo from '../assets/images/Invent_Logo_2COL_RGB.svg';

library.add(faShoePrints);


function GetExplanation({explanation}){
    if(explanation){
        return(
            <>
                <hr />
                <div className="response-expl">{returnJSX(explanation)}</div>
            </>
        )
    }
    else{
        return(
            <>
            </>
        )
    }
}

function GetIcon({index}){
    if(index===1){
        return(
            <FontAwesomeIcon 
                icon="shoe-prints" 
                color="#A6001A"
            />
        )
    }
    if(index===2){
        return(
            <FontAwesomeIcon 
                icon="shoe-prints" 
                color="#E30021"
            />
        )
    }
    if(index===3){
        return(
            <FontAwesomeIcon 
                icon="shoe-prints" 
                color="#FF9C29"
            />
        )
    }
    else{
        return(
            <FontAwesomeIcon 
                icon="shoe-prints" 
                color="#178C3D"
            />
        )
    }
}

function ListResponses({ response }) {
  
    let lists = response[0].steps.slice(); 
    lists = lists.sort((a, b) => (a.seq > b.seq) ? 1 : -1);
    // console.log(lists);
    // console.log(response[0].steps)
    return lists.map((res, index) => {
        let checkIndex = index;
        // console.log(response[0].steps.findIndex(step =>step.sid === res.sid), checkIndex)
        if (checkIndex == response[0].steps.findIndex(step =>step.sid === res.sid)) {
            return (
                <ListGroup.Item key={res.sid}>
                    <div className="response-list-box">
                        <div className="choice-order-number">
                            <h3>{ordinal_suffix_of(checkIndex+1)}</h3>
                        </div>
                        <div className="response-grey-box">
                            <div className="correct-h6">
                                <i className="fa fa-check-circle"></i><h6>Correct</h6>
                            </div>
                            <div className="response-desc d-flex">
                                <div className="response-icon">
                                    <GetIcon 
                                        index = {checkIndex+1}
                                    />
                                </div>
                                {returnJSX(res.description)}
                            </div> 
                            <GetExplanation
                                explanation={res.explanation}
                            />
                        </div>
                    </div>
                </ListGroup.Item>
            )
        }
        else {
            return (
                <ListGroup.Item key={res.sid}>
                    <div className="response-list-box">
                        <div className="choice-order-number">
                            <h3>{ordinal_suffix_of(checkIndex+1)}</h3>
                        </div>
                        <div className="response-grey-box">
                            <div className="incorrect-h6">
                                <i className="fa fa-times-circle"></i><h6>Incorrect</h6>
                            </div>
                            <div className="response-desc d-flex">
                                <div className="response-icon">
                                    <GetIcon 
                                        index = {checkIndex+1}
                                    />
                                </div>
                                {returnJSX(res.description)}
                            </div>
                            <GetExplanation
                                explanation={res.explanation}
                            />
                        </div>
                    </div>
                </ListGroup.Item>
            )
        }
    })
}

function ListRecommendations({ response }) {
    return response[0].recommendations.map((res, index) => {

        return (
            <ListGroup.Item key={index}>
                {returnJSX(res)}
            </ListGroup.Item>
        )
    })
}

class Response extends React.Component {

    constructor(props) {
        super(props);

        this.GetButtonText = this.GetButtonText.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    GetButtonText = (order) => {
        // console.log("order: ",order);
        if (order === 10) {
            return "Check My Score";
        }
        else {
            return "Next Question";
        }
    }

    render() {
        return (
            <>
                <div className="challenge-banner d-flex">
                    <div className="cg-logo">
                        <img src={cgInventLogo} alt="Capgemini Logo" width="150" />
                    </div>
                    <img className="challenge-banner-img" src={challengeImage} alt="Challenge page banner image" />
                    
                    <div className="white-text-box d-flex">
                        <div className="d-flex header-white-txt">
                            <h5>
                                {this.props.order - 1} of 10
                                <ProgressBar now={(this.props.order - 1) * 10} />
                            </h5>
                            <h4 className="thankyou-h4">{this.props.currentState[0].title}</h4>
                        </div>
                    </div>
                </div>
                <p className="blue-text p-2 blue-text-resp">
                    {returnJSX(this.props.currentState[0].description)}
                    <i>&nbsp;{returnHint(this.props.currentState[0].hint)}</i>
                </p>
                <ListGroup>
                    <ListResponses
                        response={this.props.currentState}
                    />
                </ListGroup>
                <div className="wrap-box">
                    <div className="recommendations-block">
                        <h4><i className="fa fa-leaf mr-1"></i> Recommendations</h4>
                        <ListGroup>
                            <ListRecommendations
                                response={this.props.currentState}
                            />
                        </ListGroup>
                    </div>
                </div>
                <div className="d-flex main-button-row">
                    <Button
                        variant="primary"
                        onClick={() => this.props.updateNextQuestion()}
                    >
                        {this.GetButtonText(this.props.currentState[0].order)}
                    </Button>
                </div>
                <Footer />
            </>
        )
    }
}

export default Response;